import { Stack, Typography } from "@mui/material";
import React from "react";

export default function NotFoundPage() {

    return (
        <Stack sx={{width: "100%", height: "200px"}} justifyContent="center" alignItems="center">
            <Typography variant="h2" textAlign="center">404 Not found</Typography>
        </Stack>
    )
}